import React from 'react';
import { useTranslation } from 'react-i18next';

type JobSourceId = 'naukri' | 'linkedin' | 'peerlist' | 'indeed' | 'internshala';

const PLATFORMS: { id: JobSourceId; nameKey: string }[] = [
  { id: 'naukri', nameKey: 'home.hero.platforms.naukri' },
  { id: 'linkedin', nameKey: 'home.hero.integrations.global.linkedin' },
  { id: 'peerlist', nameKey: 'home.hero.jobSources.peerlist' },
  { id: 'indeed', nameKey: 'home.hero.integrations.global.indeed' },
  { id: 'internshala', nameKey: 'home.hero.integrations.global.internshala' },
];

function PlatformIcon({ id }: { id: JobSourceId }) {
  const className = 'auth-pin-platforms__icon';

  switch (id) {
    case 'naukri':
      return (
        <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
          <rect x="4" y="4" width="24" height="24" rx="6" stroke="currentColor" strokeWidth="1.5" />
          <path
            d="M11 22V10h3.2l3.4 7.2L21 10H24v12h-2.6v-7.1L18.2 22h-2.1l-3.2-7.1V22H11z"
            fill="currentColor"
          />
        </svg>
      );
    case 'linkedin':
      return (
        <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
          <rect x="5" y="5" width="22" height="22" rx="5" stroke="currentColor" strokeWidth="1.5" />
          <path d="M11 14v7M11 11.5v.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
          <path
            d="M15 21v-4.2c0-1.4.9-2.3 2.2-2.3 1.2 0 1.8.8 1.8 2.3V21M21 14v7"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'peerlist':
      return (
        <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
          <circle cx="16" cy="16" r="10" stroke="currentColor" strokeWidth="1.5" />
          <path
            d="M11.5 16.5c1.8-2.2 3.5-3.3 4.5-3.3s2.7 1.1 4.5 3.3M13 20.5c1.2-1.4 2.2-2.1 3-2.1s1.8.7 3 2.1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle cx="16" cy="12.5" r="2" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      );
    case 'indeed':
      return (
        <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
          <rect x="6" y="11" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.5" />
          <path d="M12 11V9a4 4 0 018 0v2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M6 16h20" stroke="currentColor" strokeWidth="1.5" />
          <circle cx="16" cy="19" r="1.25" fill="currentColor" />
        </svg>
      );
    case 'internshala':
      return (
        <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
          <path d="M16 7v18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <path
            d="M10 11l6-4 6 4M8 24h16"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M12 17h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    default:
      return null;
  }
}

const AuthPinPlatformCarousel: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="auth-pin-platforms" aria-hidden>
      {PLATFORMS.map((platform) => (
        <span key={platform.id} className="auth-pin-platforms__item">
          <PlatformIcon id={platform.id} />
          <span className="auth-pin-platforms__label">{t(platform.nameKey)}</span>
        </span>
      ))}
    </div>
  );
};

export default AuthPinPlatformCarousel;
